import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetTransferRequestsProps } from "@/services/transfer-requests.service";
import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber } from "@/utils/query-string";

export interface TRFRProps {
  request_date?: Dayjs;
  sucursal: number[];
  request_amount: string;
  requester: string;
  request_type: string[];
  origin_account: Option;
  destiny_account: Option | string;
  estados?: Array<number | string>;
}

const resolveEstadoIdsForScheduled = (
  rawEstadoValues: Array<number | string> | undefined,
  _scheduled: boolean,
): number[] => {
  const selectedIds = (rawEstadoValues ?? [])
    .flatMap((value) => {
      if (typeof value === "string") {
        return value
          .split("|")
          .map(Number)
          .filter((v) => !Number.isNaN(v));
      }

      if (typeof value === "number") return [value];

      return [];
    })

  return [...new Set(selectedIds)];
};

export const getTransferRequestFilter = (
  event: TRFRProps,
  scheduled = false,
  dateField: "Fecha" | "FechaEjecucion" = "Fecha",
): Partial<GetTransferRequestsProps> => {
  let amount: number | undefined;
  const destinationAccount =
    typeof event?.destiny_account === "string"
      ? event.destiny_account
      : event?.destiny_account?.value;

  if (event?.request_amount) {
    const num = formatCurrencyInputToNumber(event.request_amount);

    if (!Number.isNaN(num)) {
      amount = Number(num.toFixed(2));
    }
  }

  return {
    ...(event?.request_date && dayjs(event?.request_date).isValid()
      ? {
          [dateField]: dayjs(event?.request_date).toISOString(),
        }
      : {}),
    ...(event?.estados?.length
      ? {
          estados: resolveEstadoIdsForScheduled(event.estados, scheduled),
        }
      : {}),
  
    ...(event?.origin_account
      ? {
          nroCuenta: String(event?.origin_account?.value),
        }
      : {}),
    ...(destinationAccount
      ? {
          cuentaDestino: String(destinationAccount),
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          monto: Number(amount),
        }
      : {}),
    ...(event?.requester
      ? {
          solicitante: event?.requester,
        }
      : {}),
  };
};
